<template>

<div>
  <form @submit.prevent="sendMessage" class="pa4-ns pa2 h-100 w-100 textColor">
    <label for="message" class="f6 b db mb2">{{ $t("form.message") }}:</label>
    <span class="errorText ma1 f7" v-if="$v.message.$error && !$v.message.required">{{ $t("error.messageRequired") }}</span>
    <span class="errorText ma1 f7" v-if="$v.message.$error && !$v.message.maxLength">{{ $t("error.messageMaxLength") }}</span>
    <textarea id="message" name="message" v-model="message" @blur="$v.message.$touch"
              class="h4 f7 db border-box w-100 ba b--black-20 pa2 br2 mb2 textAreaContact"
              :class="{error: $v.message.$error}"
              aria-describedby="comment-desc"
              :placeholder="$t('artists.contact.messagePlaceholder')"></textarea>
    <div class="w-100 pa2 flex justify-end">
      <input class="ttu tracked tabs ba ph3 pv2 input-reset bg-primary textColor bg-transparent grow pointer f6" type="submit"
      :value="$t('form.send')">
    </div>
  </form>
</div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { required, maxLength } from 'vuelidate/lib/validators'

  export default {
    name: 'artist-contact',
    data () {
      return {
        message: ''
      }
    },
    methods: {
      ...mapActions('artist', [
        'contact'
      ]),
      sendMessage () {
        if (!this.$v.$invalid) {
          this.contact({message: this.message, artist_id: this.artist.id, userEmail: this.user.email, userFirstName: this.user.first_name, userLastName: this.user.last_name, username: this.user.user_name}).then(() => {
            this.message = ''
            this.$v.$reset()
            this.$toasted.show(this.$t('artists.contact.success'), {type: 'success'})
          }).catch((e) => {
            this.$toasted.show(e.message, {type: 'error'})
          })
        } else {
          this.$v.$touch()
        }
      }
    },
    computed: {
      ...mapGetters('artist', [
        'artist'
      ]),
      ...mapGetters('user', [
        'user'
      ])
    },
    validations: {
      message: {
        required,
        maxLength: maxLength(2048)
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import '~@/variables.scss';

  .error {
    border: 1px solid rgba(255, 0, 0, 0.7);
  }
  .textAreaContact {
    background-color: $background-color;
    color: white;
  }

</style>


// WEBPACK FOOTER //
// src/components/artistProfile/ArtistContact.vue